// extracted by mini-css-extract-plugin
export default {"login-form":"AuthForm_login-form__vSMnS","control":"AuthForm_control__8syV0","error":"AuthForm_error__Q4teO","submit":"AuthForm_submit__D9ImH","switch":"AuthForm_switch__GtsPZ"};